/** The file changed since it was read; writing now would overwrite someone's work. */
export class ConflictError extends Error {
  path: string;
  constructor(path: string) {
    super(`${path} changed since it was opened.`);
    this.name = "ConflictError";
    this.path = path;
  }
}

/** A file with that name already exists. */
export class ExistsError extends Error {
  path: string;
  constructor(path: string) {
    super(`${path} already exists.`);
    this.name = "ExistsError";
    this.path = path;
  }
}

/** There is no file with that name. */
export class NotFoundError extends Error {
  path: string;
  constructor(path: string) {
    super(`${path} was not found.`);
    this.name = "NotFoundError";
    this.path = path;
  }
}

/** The browser no longer lets the app touch the folder; the writer must allow it again. */
export class PermissionError extends Error {
  constructor(message = "Access to the folder was not allowed.") {
    super(message);
    this.name = "PermissionError";
  }
}

/** A short unique token used as a file's version where the platform gives none. */
export function newVersion() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

/** @param {string} text */
export function byteLength(text: string): number {
  return new TextEncoder().encode(text).length;
}
